import * as React from 'react';
import { uniqWith } from 'rambda';
import { WishListItem, Subject } from '@packages/common';
export const LOCAL_STORAGE_KEY = 'mde_wishlist';

export interface WishlistContextValues {
  wishlistSubject: Subject<WishListItem[]>;
}

export const WishlistContext = React.createContext<WishlistContextValues>({} as any);

export function getWishlistItemsFromLocalStorage(localStorageKey: string): WishListItem[] {
  try {
    const wishlistV2 = localStorage.getItem(localStorageKey);
    if (wishlistV2) {
      return JSON.parse(wishlistV2);
    }
    const data = localStorage.getItem('persist:root');
    if (data) {
      const dataObject = JSON.parse(data || '');
      const wishtlistDataRaw = dataObject && dataObject.wishList;
      const wishlistData = JSON.parse(wishtlistDataRaw);
      return wishlistData.savedItems;
    }
    return [];
  } catch (e) {
    console.error(e);
    return [];
  }
}

function syncLocalStorage(items: WishListItem[], localStorageKey: string) {
  try {
    localStorage.setItem(localStorageKey, JSON.stringify(items));
  } catch (error) {
    console.log(error);
  }
}

export const WishlistProvider: React.FC<{ localStorageKey: string }> = ({
  children,
  localStorageKey = LOCAL_STORAGE_KEY,
}) => {
  const wishlistSubject = React.useRef(new Subject<WishListItem[]>([]));

  React.useEffect(() => {
    const { unsubscribe } = wishlistSubject.current.subscribe((next) => {
      syncLocalStorage(next, localStorageKey);
    });
    return unsubscribe;
  }, [localStorageKey]);

  React.useEffect(() => {
    const updatedWishlistItems = uniqWith(
      (a: WishListItem, b: WishListItem) => a?.productId === b?.productId,
      [...getWishlistItemsFromLocalStorage(localStorageKey)],
    ) as WishListItem[];

    wishlistSubject.current.next(updatedWishlistItems);
  }, [localStorageKey]);

  return (
    <WishlistContext.Provider value={{ wishlistSubject: wishlistSubject.current }}>{children}</WishlistContext.Provider>
  );
};
